import { render, staticRenderFns } from "./ArtAdherence.vue?vue&type=template&id=2fde1b57&"
import script from "./ArtAdherence.vue?vue&type=script&lang=js&"
export * from "./ArtAdherence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports